// src/lib/api.ts
import { QueryClient } from "@tanstack/react-query";
function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 3e4,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }
          return failureCount < 2;
        }
      },
      mutations: {
        retry: false
      }
    }
  });
}
var ApiError = class extends Error {
  constructor(status, statusText, body, message) {
    super(message ?? deriveMessage(status, statusText, body));
    this.status = status;
    this.statusText = statusText;
    this.body = body;
    this.name = "ApiError";
  }
};
function deriveMessage(status, statusText, body) {
  const fallback = `${status} ${statusText}`;
  if (body == null || typeof body !== "object") return fallback;
  const b = body;
  const detail = typeof b.detail === "string" ? b.detail : void 0;
  const errStr = typeof b.error === "string" ? b.error : void 0;
  const msgStr = typeof b.message === "string" ? b.message : void 0;
  const codeStr = typeof b.code === "string" ? b.code : void 0;
  const reason = detail ?? errStr ?? msgStr ?? codeStr;
  return reason ? `${fallback} \u2014 ${reason}` : fallback;
}
function mergeHeaders(base, caller) {
  const h = new Headers(base);
  if (caller) {
    new Headers(caller).forEach((value, key) => {
      h.set(key, value);
    });
  }
  return h;
}
async function apiFetch(path, options = {}) {
  const { json, headers, credentials: _ignored, ...rest } = options;
  const baseHeaders = {
    Accept: "application/json",
    ...json !== void 0 ? { "Content-Type": "application/json" } : {}
  };
  const init = {
    ...rest,
    headers: mergeHeaders(baseHeaders, headers),
    credentials: "include",
    ...json !== void 0 ? { body: JSON.stringify(json) } : {}
  };
  const res = await fetch(path, init);
  if (res.status === 204) {
    return null;
  }
  const contentType = res.headers.get("content-type") ?? "";
  const isJson = contentType.includes("application/json");
  const body = isJson ? await res.json().catch(() => null) : await res.text();
  if (!res.ok) {
    throw new ApiError(res.status, res.statusText, body);
  }
  return body;
}
export {
  ApiError,
  apiFetch,
  createQueryClient
};
//# sourceMappingURL=api.js.map